import { ActionType } from './action-type.enum';
import { PaymentType } from './payment-type.enum';
import { ToolType } from './tool-type.model';

export class LicenseDependentButtonModel {
  IsHeroButton = false;
  IsPaymentDetailView = false;
  PaymentType?: PaymentType;
  ActionType: ActionType = ActionType.Undefined;
  ActionTypeRange?: number;
  ButtonAlignmentRight = false;
  OpenInNewTab = false;
  ContactText = 'Contact Text';
  AdditionalButtonCss?= '';
  ButtonIcon = '';
  ShowCreditsModal = true;
  Toolname: ToolType = '';
  FullWidth = false;
}
